module.exports = __webpack_public_path__ + "img/changeProfile-2.1e49c3d.webp";